import { Trash2 } from 'lucide-react';
import { formatRelativeTime } from '../../../utils/formatters';

interface ProjectChat {
  id: number;
  chat_title: string | null;
  messages_count: number;
  updated_at: string;
  agent_name?: string;
}

interface ProjectConversationCardProps {
  chat: ProjectChat;
  onClick: () => void;
  onDelete: (e: React.MouseEvent) => void;
}

/**
 * ProjectConversationCard - Card de conversa dentro do projeto
 *
 * Layout simplificado conforme design:
 * - Título em bold
 * - Preview/descrição em cinza
 * - Tempo relativo à direita
 */
export const ProjectConversationCard = ({
  chat,
  onClick,
  onDelete
}: ProjectConversationCardProps) => {
  // Generate preview text based on messages count
  const getPreview = () => {
    if (chat.messages_count === 0) return 'Sem mensagens';
    // This would ideally come from the first message, but we'll use a placeholder
    return `${chat.messages_count} mensagen${chat.messages_count === 1 ? '' : 's'}`;
  };

  return (
    <div
      onClick={onClick}
      className="
        flex items-center justify-between p-4
        bg-[#1a1a1a] border border-[#333333] rounded-lg
        hover:border-[#F4CC04] cursor-pointer
        transition-colors group
      "
    >
      {/* Left: Title and preview */}
      <div className="flex-1 min-w-0 mr-4">
        <h3 className="text-white font-semibold text-base mb-1 truncate">
          {chat.chat_title || 'Nova conversa'}
        </h3>
        <p className="text-[#666666] text-sm truncate">
          {getPreview()}
        </p>
      </div>

      {/* Right: Time and delete */}
      <div className="flex items-center gap-3 flex-shrink-0">
        <span className="text-[#666666] text-sm">
          {formatRelativeTime(chat.updated_at)}
        </span>
        <button
          onClick={onDelete}
          className="
            p-1.5 rounded-lg text-[#666666]
            opacity-0 group-hover:opacity-100
            hover:text-red-400 hover:bg-[#333333]
            transition-all
          "
          title="Excluir conversa"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
